module.exports = __webpack_public_path__ + "img/Bodice-Front-B4-Jbcd.634cf725.png";